export default __webpack_public_path__ + "static/media/rec.mtex.app.957043df.png";